import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { useState, useEffect, useRef } from 'react';
import { scrollIntoView } from '../utils';
import OnDarkContext from '../OnDarkContext';
import Layer from '../Layer';
import SpotPulsar from './SpotPulsar';
import SpotPopup from './SpotPopup';

var isEqual = function isEqual(a, b) {
  return a.top === b.top && a.left === b.left && a.right === b.right && a.bottom === b.bottom && a.width === b.width && a.height === b.height;
};
/**
 * The component can be used to attract the user's attention to a specific element on the page.
 * @since 3.0.1
 */


var Spot = function Spot(_ref) {
  var selector = _ref.selector,
      popup = _ref.popup,
      meta = _ref.meta,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, ["selector", "popup", "meta", "placement"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1];

  var pulsarRef = useRef(null);
  useEffect(function () {
    var lastRect;
    var lastPageYOffset = window.pageYOffset;
    var isMoving = false;
    var needUpdate = false;
    var needScrollIntoView = true;

    var check = function check() {
      var node = document.querySelector(selector);

      if (node) {
        var nextRect = node.getBoundingClientRect();

        if (!lastRect) {
          isMoving = true;
          lastRect = nextRect;
        } else if (!isEqual(nextRect, lastRect) || window.pageYOffset !== lastPageYOffset) {
          isMoving = true;
          lastPageYOffset = window.pageYOffset;
          lastRect = nextRect;
        } else if (isMoving) {
          isMoving = false;
          needUpdate = true;
        }

        if (needUpdate) {
          setRect(nextRect);
          needUpdate = false;

          if (needScrollIntoView) {
            needScrollIntoView = false;
            scrollIntoView(node, {
              scrollMode: 'if-needed'
            });
          }
        }
      } else {
        setRect(undefined);
      }
    };

    check();
    var retryId = window.setInterval(check, 125);
    return function () {
      window.clearInterval(retryId);
    };
  }, [selector]);

  if (!rect) {
    return null;
  }

  var pulsar = React.createElement(SpotPulsar, _extends({
    rect: rect,
    placement: placement
  }, props, {
    ref: pulsarRef
  }));
  return React.createElement(OnDarkContext.Provider, {
    value: true
  }, React.createElement(Layer, null, popup ? React.createElement(SpotPopup, _extends({
    pulsar: pulsar,
    pulsarRef: pulsarRef,
    meta: meta
  }, popup)) : React.createElement("div", null, pulsar)));
};

export default Spot;